import { useState, useEffect, useCallback } from 'react'
import { SunspotLoader } from 'react-awesome-loaders'

import StepThreeExamInfo from './StepThreeExamInfo'
import { InputField } from 'components/shared/InputField'
import DatePickerField from 'components/shared/DatePickerField'
import { changeToIst } from 'utils/dateTime'
import { useLocation } from 'react-router-dom'

import useGetApi from 'api/useGetApi'
import config from 'config'
import SelectCreatable from 'utils/SelectDropdown'
import { getIPData, getIPLepton } from 'api/api'

import cx from 'classnames'
import { Button, Modal } from 'reactstrap'
import styles from './signupStyles.module.css'
import { usePutPostApi } from 'api/usePutPostApi'
import { getExamType } from 'utils/common'
import { SET_TOAST_DATA } from 'constants/actionTypes'
import { connect, useDispatch } from 'react-redux'

const mapDispatchToProps = (dispatch) => ({
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
})

const GeneralStepTwoUserInfo = ({
    registration_page,
    defaultUserInfo,
    isNewUser,
    userMethod,
    setSignupSuccessDetails,
    isSfNewUser,
}) => {
    const { mobileNumber } = defaultUserInfo
    const examType = getExamType()
    const utmParams = JSON.parse(sessionStorage.getItem('utmParams'))
    const queryString = window.location.href
    const url = new URL(queryString)
    const [geolocationData, setGeolocation] = useState()

    const [userInfo, setUserInfo] = useState(defaultUserInfo)

    const dispatch = useDispatch()

    const showToast = useCallback(() => {
        dispatch({
            type: SET_TOAST_DATA,
            payload: {
                isToastOpen: true,
                toastType: 'danger',
                toastMessage: 'Something went wrong, try again later',
            },
        })
    },[dispatch])

    useEffect(() => {
        if (defaultUserInfo.dob && typeof defaultUserInfo == 'object') {
            setUserInfo({
                ...defaultUserInfo,
                dob: new Date(defaultUserInfo.dob), // Convert date format
            })
        }
    }, [defaultUserInfo])

    const [errorMsg, setErrorMsg] = useState({
        studentName: '',
        // fatherName: '',
        email: '',
        dob: '',
    })

    const [examInfo, setExamInfo] = useState({
        schoolBoard: { value: 'CBSE', label: 'CBSE' },
        classStream: '',
        examSlots: '',
        state: '',
        centre: '',
        dateOfExam: '',
        coachingState: '',
        coachingBranch: ''
    })
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const student_sf_id = queryParams.get('sf_id')


    const [dropdownOptions, setDropdownOptions] = useState({
        schoolBoard: [],
        classStream: [],
        coachingStates: [],
        coachingBranches: [],
        state: [],
        centre: [],
        dateOfExam: [],
        examSlots: [],
    })

    const [errors, setErrors] = useState({
        schoolBoard: '',
        classStream: '',
        state: '',
        centre: '',
        dateOfExam: '',
    })

    const [isFormHidden, setIsFormHidden] = useState(false)

    const signupPayload = {
        student_name: userInfo.studentName,
        student_email: userInfo.email.toLowerCase(),
        student_dob: changeToIst(userInfo.dob), // yyyy-mm-dd
        student_mobile_no: userInfo.mobileNumber,
        school_board: examInfo.schoolBoard.value,
        class_stream: examInfo.classStream.value,
        gclid: localStorage.getItem('gclid') || '',
        ...utmParams,
        whatsapp_status: true, //! whatsapp_optin always `true`
        ...(student_sf_id && { student_sf_id: student_sf_id }),
        ...(examType === 'MOCK-JEE' && {
            exam_state: 18,
            branch_code: 'HO413',
            exam_date: '2026-02-20',
            exam_mode: 'Online - Morning 11:00 AM to 5:00 PM',
        }),
    }

    const [storedStudentInfo, setStoredStudentInfo] = useState(
        JSON.parse(localStorage.getItem('studentInfo')) || {}
    );
    useEffect(() => {
        const handleStorageChange = () => {
            setStoredStudentInfo(JSON.parse(localStorage.getItem('studentInfo')) || {});
        };
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);
    

    useEffect(() => {
        if (dropdownOptions.classStream.length > 0) {
            let matchedClassStream = null;

            const storedClassStream = storedStudentInfo.classtream || ''
            if (storedClassStream) {
                matchedClassStream = dropdownOptions.classStream.find((v) =>
                            v.stream.toLowerCase() ===
                            storedClassStream.toLowerCase() ||
                            v.value.toString() === storedClassStream)

                if (matchedClassStream) {
                    setDropdownOptions((prevOptions) => ({
                        ...prevOptions,
                        classStream: [matchedClassStream], // Set as a single object array
                    }))
                }
            } 
            
            if (!matchedClassStream && userInfo.classStream) { // Set previous class selected
                const selectedVal = dropdownOptions.classStream.find((option) => option.stream.toString() === userInfo.classStream)
                if(selectedVal){
                    setExamInfo((s) => ({ ...s, classStream: selectedVal }))
                    setHideNext(false)
                }
            }
        }
    }, [storedStudentInfo, dropdownOptions.classStream.length])

    const {
        data: partialData,
        loading: isSignupLoading,
        error: signupError,
        setPutEnabled: callSignupApi,
    } = usePutPostApi(config.SIGNUP_API, '', 'post', signupPayload, false)

    // API hooks to fetch dropdown options
    const { data: schoolBoardData } = useGetApi(config.FETCH_SCHOOL_BOARD, '', true)
    const { data: classStreamData } = useGetApi(
        config.FETCH_CLASS_STREAM + '/?registration_page=' + registration_page,
        '',
        true,
    )

    const { data: nearestCentreData, setEnabled: getNearestCentre } = useGetApi(
        `${config.NEAREST_CENTRE}/${geolocationData?.latitude}/${geolocationData?.longitude}/${examInfo.classStream.value}/${examInfo?.examSlots?.label?.includes('Offline') ? "Offline" : "Online"}`,
        '',
        false,
    )

    const [isFormValid, setIsFormValid] = useState(false)
    const [isExamDetailsFormVisible, setExamDetailsFormVisibile] = useState(false)

    const [hideNext, setHideNext] = useState(true)

    const isSubmitBtnDisabled = !isFormValid
    const Loader = (
        <SunspotLoader
            gradientColors={['#4039d4', '#E0E7FF']}
            size={'10px'}
            desktopSize={'10px'}
            className="m-auto"
        />
    )

    useEffect(() => {
        const userInfoValues = Object.values(userInfo).some((val) => val === '')
        const errorValues = Object.values(errorMsg).some((val) => val)

        setIsFormValid(!userInfoValues && !errorValues)
    }, [userInfo, errorMsg])

    useEffect(() => {
        if (
            isFormValid &&
            examInfo.schoolBoard !== '' &&
            examInfo.classStream !== '' &&
            isFormHidden === true &&
            examType !== 'MOCK-JEE'
        ) {
            /**
             * show Exam details form when userInfo &
             * Board, class&stream (2 fields of examInfo) dropdowns are filled
             * with no errors
             */

            setExamDetailsFormVisibile(true)
        }

        // todo version 2: call API to save userInfo
    }, [isFormValid, examInfo, errors, isFormHidden, examType])

    useEffect(() => {
        if (partialData && partialData?.success) {
            if (examType === 'MOCK-JEE') {
                setSignupSuccessDetails({
                    isSignupSuccessful: true,
                    ...partialData?.data,
                    exam_date: signupPayload.exam_date,
                })
            }

            setIsFormHidden(true)
        }
        if (partialData && !partialData?.success) {
            showToast()
        }
    }, [examType, partialData, setSignupSuccessDetails, signupPayload.exam_date])

    useEffect(() => {
        if (classStreamData?.success && Object.keys(classStreamData?.data).length) {
            const classData = classStreamData?.data
            const classStreamOptions = []
            for (const key in classData) {
                if (Object.prototype.hasOwnProperty.call(classData, key)) {
                    classStreamOptions.push({
                        label: classData[key].display_name,
                        value: key,
                        stream: classData[key].stream,
                        class: classData[key].stream.split('&')[0],
                    })
                }
            }

            classStreamOptions.sort((a, b) => a.class - b.class)

            setDropdownOptions({
                ...dropdownOptions,
                classStream: classStreamOptions,
            })
        }
    }, [classStreamData])

    useEffect(() => {
        const localStorage = window.localStorage
        const locData = localStorage.getItem('iacst_location')
        const parsedLoc = locData ? JSON.parse(locData) : {}
        if (parsedLoc.revalidation > Date.now()) {
            const { longitude, latitude, isLocationAllowed, city, pincode, state } =
                parsedLoc
            setGeolocation({
                longitude,
                latitude,
                isLocationAllowed: isLocationAllowed,
            })
            setUserInfo((s) => ({ ...s, city, pincode, state }))
        } else {
            getIP()
            navigator.geolocation.getCurrentPosition(({ coords }) => {
                const { longitude, latitude } = coords
                getIP({ longitude, latitude })

                setGeolocation({ longitude, latitude, isLocationAllowed: true })
            })
        }
    }, [])

    useEffect(() => {
        if (
            geolocationData?.longitude &&
            geolocationData?.latitude &&
            examInfo.classStream
        ) {
            getNearestCentre(true)
        }
    }, [examInfo.classStream, geolocationData, getNearestCentre])

  
    
    useEffect(() => {
        
        if (nearestCentreData) {
            if (nearestCentreData?.data?.length > 0) {
        
                const {
                    data: [{ state_code: state, center_name: centre }],
                } = nearestCentreData
               
                setExamInfo((s) => ({
                    ...s,
                    ...(!s.state
                        ? { autoFill: { state, centre } }
                        : { nearest: { state, centre } }), // stop resetting of "centre" state on "state" state change
                }))
            } else {
                console.error('No centre found')
            }
        }
    }, [nearestCentreData])

    const getIP = async (locationAccess) => {
        try {
            if (locationAccess) {
                const { data } = await getIPLepton(locationAccess)
                const { city, state, pincode } = data

                const geoloc = {
                    ...locationAccess,
                    city,
                    pincode,
                    state,
                    isLocationAllowed: true,
                }
                setUserInfo((s) => ({ ...s, city, pincode, state }))

                localStorage.setItem(
                    'iacst_location',
                    JSON.stringify({
                        ...geoloc,
                        revalidation: Date.now() + 5184000,
                    }),
                )
            } else {
                const { data } = await getIPData()
                const { longitude, latitude, city, postal, region } = data

                const geoloc = {
                    longitude,
                    latitude,
                    city,
                    pincode: postal,
                    state: region,
                    isLocationAllowed: false,
                }
                setGeolocation(() => geoloc)
                setUserInfo((s) => ({ ...s, city, pincode: postal, state: region }))

                localStorage.setItem(
                    'iacst_location',
                    JSON.stringify({
                        ...geoloc,
                        revalidation: Date.now() + 5184000,
                    }),
                )
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleFormDataChange = (event) => {
        const { name, value } = event.target
        if (name === 'studentName') {
            // Restrict dots
            if (value.includes('.')) {
                return
            }
        }
        const sanitizedValue = value
            .split('')
            .map((char, index) => {
                if (index < 2 && char === ' ') {
                    return ''
                }
                return char
            })
            .join('')

        setUserInfo({ ...userInfo, [name]: sanitizedValue })

        if (errorMsg[name]) {
            setErrorMsg((preErrorStates) => {
                return {
                    ...preErrorStates,
                    [name]: '',
                }
            })
        }
    }

    const handleDobChange = (date) => {
        setUserInfo({ ...userInfo, dob: date })

        setErrorMsg({
            ...errorMsg,
            dob: '',
        })
    }

    const handleOnChange = ({ name, value }) => {
        
        setExamInfo((s) => ({
            ...s,
            [name]: value,
            ...( (name === 'state' || name === 'centre' || name === 'coachingState' || name === 'coachingBranch' ) && { autoFill: false } ),

            ...(name === 'examSlots' && {
                dateOfExam: '',
            }),
            ...(name === 'state' && { dateOfExam: '' }),
             ...(name === 'centre' && { dateOfExam: '' }),
             ...(name === 'coachingState' && {dateOfExam: ''}),
             ...(name === 'coachingBranch' && {dateOfExam: ''}),
        }))
        // if(name === "examSlots" && value?.label.includes('Offline')){
        //     getNearestCentre(true);
        // }
    }

    const handleClassStreamOnChange = ({ name, value }) => {
        setExamInfo((s) => ({
            ...s,
            [name]: value,
            autoFill: false,
            ...(name === 'state' && {
                centre: '',
                dateOfExam: '',
            }),
            ...(name === 'centre' && { dateOfExam: '' }),
        }))

        setUserInfo({ ...userInfo, classStream: value.stream || value.value })
        setHideNext(false)
    }

    const handleErrorsOnChangeCourseType = () => {
        setErrors((err) => ({
            ...err,
            state: '',
            centre: '',
            dateOfExam: '',
        }))
    }

    const handleUpdateErrors = (name, error) => {
        const MIN_NAME_LENGTH = 2
        if (name.length < MIN_NAME_LENGTH) {
            return 'Minimum length should be 2'
        }
        setErrorMsg((err) => ({
            ...err,
            [name]: error,
        }))

        // only trigger WebEngage event when `error` value is not empty
        if (error) {
            const fieldErrors = { ...errorMsg, [name]: error }

            // web-analytics
            const {
                studentName: student_name,
                // fatherName: father_name,
                email: email_ID,
                dob,
                schoolBoard: Board,
            } = fieldErrors
            if (examType == 'IAT' || examType=="MOCK-JEE") {
                window.webengage.track(examType + '_2_Student_Info_Error', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    psid: userMethod.psid,
                    'mobile number': mobileNumber,
                    pincode: userInfo.pincode ? userInfo.pincode : '',
                    state: userInfo.state ? userInfo.state : '',
                    city: userInfo.city ? userInfo.city : '',
                    exam_type: examType,
                })
            }
        }
    }

    const handleExamErrors = (name, error) => {
        setErrors((err) => ({
            ...err,
            [name]: error,
        }))

        // only trigger WebEngage event when `error` value is not empty
        if (error) {
            const fieldErrors = { ...errors, [name]: error }
            const {
                classStream: Class_n_Stream,
                state: State,
                centre: Center,
                dateOfExam: Exam_Date,
            } = fieldErrors

            // web-analytics
            if (Class_n_Stream == 'Please select class & stream') {
                window.webengage.track(examType + '_2_Student_Info_Error', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    'mobile number': userInfo.mobileNumber,
                    pincode: userInfo.pincode ? userInfo.pincode : '',
                    psid: userMethod.psid,
                    state: userInfo.state ? userInfo.state : '',
                    city: userInfo.city ? userInfo.city : '',
                    exam_type: examType,
                    // error_fields: {
                    //     Class_n_Stream,
                    //     State,
                    //     Center,
                    //     Exam_Date,
                    // },
                })
            } else {
                window.webengage.track(examType + '_4_Exam_Details_Error', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    psid: userMethod.psid ? userMethod.psid : '',
                    'mobile number': userInfo.mobileNumber
                        ? userInfo.mobileNumber
                        : '',
                    board: examInfo.schoolBoard.value
                        ? examInfo.schoolBoard.value
                        : '',
                    student_name: userInfo.studentName ? userInfo.studentName : '',
                    class: examInfo.classStream.class
                        ? examInfo.classStream.class
                        : '',
                    email_id: userInfo.email ? userInfo.email : '',
                    dob: changeToIst(userInfo.dob) ? changeToIst(userInfo.dob) : '',
                    pincode: userInfo.pincode ? userInfo.pincode : '',
                    state: userInfo.state ? userInfo.state : '',
                    city: userInfo.city ? userInfo.city : '',
                    exam_type: examType,
                    exam_fee: partialData.data.exam_fee
                        ? Number(partialData.data.exam_fee)
                        : '',
                })
            }
        }
    }

    const handleDobOnBlur = (userSelectedDob, event = 'select') => {
        if (userSelectedDob === '' || userSelectedDob === null) {
            setErrorMsg({ ...errorMsg, dob: 'Please select date of birth' })
            if (examType == 'IAT' || examType=="MOCK-JEE"
            ) {
                window.webengage.track(examType + '_2_Student_Info_Error', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    psid: userMethod.psid,
                    'mobile number': userInfo.mobileNumber,
                    pincode: userInfo.pincode ? userInfo.pincode : '',
                    state: userInfo.state ? userInfo.state : '',
                    city: userInfo.city ? userInfo.city : '',
                    exam_type: examType,
                })
            }
        }
    }

    const getSelectDefaultValue = (value, array, key = 'value') => {
        if (value === '') return false        
        const isPresent = Array.isArray(array) && array?.find(
            (a) =>
                a?.value?.toString().toLowerCase() ===
                    value?.value?.toString().toLowerCase() ||
                a?.[key]?.toString().toLowerCase() ===
                    value?.value?.toString().toLowerCase(),
        )
        if (isPresent) return isPresent
        return false
    }

    const handleSubmitMock = () => {
        if (examType == 'MOCK-NEET' || examType == 'IAT' || examType=="MOCK-JEE") {
            localStorage.setItem('user_psid', userMethod.psid ? userMethod.psid : '')
            window.webengage.track(examType + '2_Student_Info', {
                'utm parameters': utmParams,
                method: userMethod.isPsid ? 'psid' : 'mobile',
                psid: userMethod.psid ? userMethod.psid : '',
                'mobile number': userInfo.mobileNumber ? userInfo.mobileNumber : '',
                board: examInfo.schoolBoard.value ? examInfo.schoolBoard.value : '',
                student_name: userInfo.studentName ? userInfo.studentName : '',
                class: examInfo.classStream.class ? examInfo.classStream.class : '',
                email_id: userInfo.email ? userInfo.email : '',
                dob: changeToIst(userInfo.dob) ? changeToIst(userInfo.dob) : '',
                pincode: userInfo.pincode ? userInfo.pincode : '',
                state: userInfo.state ? userInfo.state : '',
                city: userInfo.city ? userInfo.city : '',
                exam_type: examType,
            })
        }

        // if (examType == "iACST") {
            // window.webengage.track('iACST_2_Student_Info', {
            //     'utm parameters': utmParams,
            //     method: userMethod.isPsid ? 'psid' : 'mobile',
            //     psid: userMethod.psid,
            //     'mobile number': mobileNumber,
            //     board: examInfo.schoolBoard.value,
            //     student_name,
            //     father_name,
            //     email_ID,
            //     dob: changeToIst(dob),
            // })

            window.dataLayer.push({
                event: examType+'_registration_mobile_number',
                mobile_no: userInfo.mobileNumber,
            })

            window.dataLayer.push({
                event: examType+'_registration_email',
                email: userInfo.email,
            })

            window.dataLayer.push({
                event: examType+'_registration_board',
                board: examInfo.schoolBoard.value,
            })
            
            // fired when user select class and stream
            window.dataLayer.push({
                event: examType+'_class_stream',
                class: examInfo.classStream.class,
                stream: examInfo.classStream.stream.split('&')[1]
            })
        // }

        window.webengage.user.setAttribute('we_first_name', (userInfo.studentName ? userInfo.studentName : ''))
        window.webengage.user.setAttribute('we_email', (userInfo.email ? userInfo.email : ''))

        callSignupApi(true)
    }

    return (
        <div>
            {/* Hide inputs when isFormHidden is true */}
            {!isFormHidden && (
                <>
                    <InputField
                        required
                        placeholder="Student name"
                        name="studentName"
                        validation="name"
                        messages={{
                            required: 'Please enter student name',
                            studentName: errorMsg.studentName,
                        }}
                        type="text"
                        value={userInfo.studentName}
                        onChange={handleFormDataChange}
                        showErrorOn="blur"
                        onErrorUpdate={handleUpdateErrors}
                        disabled={!isNewUser}
                        classNames="px-lg-4 px-3"
                    />

                    <InputField
                        required
                        placeholder="Email ID"
                        name="email"
                        validation="email"
                        messages={{
                            required: 'Please enter email',
                            studentName: errorMsg.email,
                        }}
                        type="text"
                        value={userInfo.email}
                        onChange={handleFormDataChange}
                        showErrorOn="blur"
                        onErrorUpdate={handleUpdateErrors}
                        // disabled={!isNewUser}
                        classNames="px-lg-4 px-3"
                    />

                    <DatePickerField
                        value={userInfo.dob}
                        onChange={handleDobChange}
                        onBlur={handleDobOnBlur}
                        placeholder="Enter Date of birth (DD/MM/YYYY)"
                        errorMsg={errorMsg.dob}
                        // disabled={!isNewUser}
                    />

                    <SelectCreatable
                        required
                        placeholder="Class & stream"
                        name="classStream"
                        options={dropdownOptions.classStream}
                        value={getSelectDefaultValue(
                            examInfo.classStream,
                            dropdownOptions.classStream,
                        )}
                        onChange={handleClassStreamOnChange}
                        onErrorUpdate={handleExamErrors}
                        messages={{
                            required: 'Please select class & stream',
                        }}
                        isSearchable={false}
                        className="mb-3 px-lg-4 px-3"
                        outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                            errors.classStream
                                ? `border-0`
                                : `border border-grey-100`
                        }`}
                        placeholderStyles={{ color: '#545454' }}
                        borderStyles={`2px solid #00b0f5 !important`}
                        disabled={isSfNewUser}
                    />
                    <div className="px-lg-4 px-3 pb-3 pt-1">
                        <Button
                            className={cx(
                                `btn btn-aqua text-white w-10 fw-700 font-size-mds font-size-lg-lg rounded ${styles.reg_custom_btn} ${styles.sendOtpButton}`,
                                {
                                    'bg-grey-20 text-grey-70 border-0':
                                        isSubmitBtnDisabled,
                                },
                            )}
                            onClick={handleSubmitMock}
                            disabled={
                                isSubmitBtnDisabled || isSignupLoading || hideNext
                            }
                        >
                            {isSignupLoading ? Loader : examType === 'MOCK-JEE' ? 'Submit' : 'Next'}
                        </Button>
                    </div>
                </>
            )}

            {isExamDetailsFormVisible && (
                <>
                    {!partialData ? (
                        // Show loader until partialData is available
                        <Modal
                            isOpen={true}
                            backdrop={true}
                            centered
                            className={styles.customModalLoader}
                        >
                            <SunspotLoader
                                gradientColors={['#4039d4', '#E0E7FF']}
                                size={'10px'}
                                desktopSize={'30px'}
                                mobileSize={'20px'}
                                className="m-auto"
                            />
                        </Modal>
                    ) : (
                        // Render StepThreeExamInfo when partialData is available
                        <StepThreeExamInfo
                            partialData={partialData}
                            userInfo={userInfo}
                            userMethod={userMethod}
                            isUserInfoValid={isFormValid}
                            setSignupSuccessDetails={setSignupSuccessDetails}
                            examInfo={examInfo}
                            setExamInfo={setExamInfo}
                            dropdownOptions={dropdownOptions}
                            getNearestCentre={getNearestCentre}
                            setDropdownOptions={setDropdownOptions}
                            errors={errors}
                            handleOnChange={handleOnChange}
                            handleUpdateErrors={handleExamErrors}
                            getSelectDefaultValue={getSelectDefaultValue}
                            registration_page={registration_page}
                            handleErrorsOnChangeCourseType={
                                handleErrorsOnChangeCourseType
                            }
                            isSfNewUser={isSfNewUser}
                        />
                    )}
                </>
            )}
        </div>
    )
}

export default connect(mapDispatchToProps)(GeneralStepTwoUserInfo)
